<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: mobai
 * @LastEditTime: 2023-02-15 09:26:58
-->
<template>
  <div class="app-container">
    <section class="title">企业申请白名单</section>
    <section class="body">
      <div>
        <p>
          每年企业首次申请白名单时，允许申请的时间。（不填写则企业无法填报）
        </p>
        <el-date-picker
          v-model="time1"
          type="daterange"
          value-format="MM-dd"
          format="MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div>
        <p>
          每年企业申请被驳回后，可再次修改提交的时间。（不填写则企业无法填报）
        </p>
        <el-date-picker
          v-model="time2"
          value-format="MM-dd"
          format="MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
    </section>
    <section class="title">普通机构入驻</section>
    <section class="body">
      <div>
        <p>
          每年企业首次申请普通机构入驻时，允许申请的时间。（不填写则企业无法填报）
        </p>
        <el-date-picker
          v-model="commonInstTime1"
          type="daterange"
          value-format="MM-dd"
          format="MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div>
        <p>
          每年企业申请普通机构入驻被驳回或退回，可再次修改提交的时间。（不填写则企业无法填报）
        </p>
        <el-date-picker
          v-model="commonInstTime2"
          value-format="MM-dd"
          format="MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
    </section>
    <section class="title">服务券机构入驻</section>
    <section class="body">
      <div>
        <p>
          每年普通机构首次申请服务券机构入驻时，允许申请的时间。（不填写则企业无法填报）
        </p>
        <el-date-picker
          v-model="serveInstTime1"
          type="daterange"
          value-format="MM-dd"
          format="MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div>
        <p>
          每年普通机构申请服务券机构入驻被驳回或退回，可再次修改提交的时间。（不填写则企业无法填报）
        </p>
        <el-date-picker
          v-model="serveInstTime2"
          value-format="MM-dd"
          format="MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
    </section>
    <section class="title">机构提交兑付资料</section>
    <section class="body">
      <el-form ref="form" label-width="80px">
        <el-form-item label="时间校验: ">
          <el-radio-group v-model="isOpen">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
          <div class="tips">
            开启后，机构必须在合同服务时间到期后，才能提交兑付资料
          </div>
        </el-form-item>
      </el-form>
    </section>
    <section class="title">服务券兑付-上传发票</section>
    <section class="body">
      <div>
        <p>
          每年中介机构首次上传发票时，允许上传的时间。（不填写则企业无法填报）
        </p>
        <el-date-picker
          v-model="invoiceTime1"
          type="daterange"
          value-format="MM-dd"
          format="MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div>
        <p>每年中介机构修改发票时，允许修改的时间。（不填写则企业无法填报）</p>
        <el-date-picker
          v-model="invoiceTime2"
          value-format="MM-dd"
          format="MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
    </section>
    <section class="foot">
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSave">保 存</el-button>
      </span>
    </section>
  </div>
</template>

<script>
import {
  queryAll,
  insertOrUpdateEntWhiteSetting,
  insertOrUpdateUploadInvoiceSetting,
  queryCommonInst,
  queryServeInst,
  queryInvoice,
  entCashQuery,
  editorCashSetting
} from '@api/yardVoucher/serviceVoucherBatchManagement/index'
export default {
  data() {
    return {
      time1: '',
      time2: '',
      commonInstTime1: '',
      commonInstTime2: '',
      serveInstTime1: '',
      serveInstTime2: '',
      invoiceTime1: '',
      invoiceTime2: '',
      isOpen: 0,
      cashId: ''
    }
  },
  watch: {},
  created() {
    this.queryByType()
    this.queryCommonInst()
    this.queryServeInst()
    this.queryInvoice()
    this.queryEntCash()
  },
  mounted() { },
  methods: {
    queryByType() {
      queryAll().then(res => {
        if (res.data.code == '0000') {
          const data = res.data.data
          this.time1 = [data[0].startTime, data[0].endTime]
          this.time2 = [data[1].startTime, data[1].endTime]
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /**
     * @description: 普通机构入驻时间获取
     * @return {*}
     */
    queryCommonInst() {
      queryCommonInst().then(res => {
        if (res.data.code == '0000') {
          const data = res.data.data
          this.commonInstTime1 = [data[0].startTime, data[0].endTime]
          this.commonInstTime2 = [data[1].startTime, data[1].endTime]
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /**
     * @description:服务机构入驻时间获取
     * @return {*}
     */
    queryServeInst() {
      queryServeInst().then(res => {
        if (res.data.code == '0000') {
          const data = res.data.data
          this.serveInstTime1 = [data[0].startTime, data[0].endTime]
          this.serveInstTime2 = [data[1].startTime, data[1].endTime]
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /**
     * @description:查询上传发票时间设置
     * @return {*}
     */
    queryInvoice() {
      queryInvoice().then(res => {
        if (res.data.code == '0000') {
          const data = res.data.data
          this.invoiceTime1 = [data[0].startTime, data[0].endTime]
          this.invoiceTime2 = [data[1].startTime, data[1].endTime]
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /**
    * @description:查询是否提交兑付资料
    * @return {*}
    */
    queryEntCash() {
      entCashQuery().then(res => {
        if (res.data.code == '0000') {
          const data = res.data.data
          this.isOpen = data.isOpen
          this.cashId = data.id
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onSave() {
      const data = {
        firstStartTime: this.time1 ? this.time1[0] : '',
        firstEndTime: this.time1 ? this.time1[1] : '',
        rejectStartTime: this.time2 ? this.time2[0] : '',
        rejectEndTime: this.time2 ? this.time2[1] : '',
        firstType: '1',
        rejectType: '2',
        intermediaryCommonFirstStartTime: this.commonInstTime1
          ? this.commonInstTime1[0]
          : '',
        intermediaryCommonFirstEndTime: this.commonInstTime1
          ? this.commonInstTime1[1]
          : '',
        intermediaryCommonRejectStartTime: this.commonInstTime2
          ? this.commonInstTime2[0]
          : '',
        intermediaryCommonRejectEndTime: this.commonInstTime2
          ? this.commonInstTime2[1]
          : '',
        intermediaryCommonFirstType: 1,
        intermediaryCommonRejectType: 2,
        intermediaryFirstStartTime: this.serveInstTime1
          ? this.serveInstTime1[0]
          : '',
        intermediaryFirstEndTime: this.serveInstTime1
          ? this.serveInstTime1[1]
          : '',
        intermediaryRejectStartTime: this.serveInstTime2
          ? this.serveInstTime2[0]
          : '',
        intermediaryRejectEndTime: this.serveInstTime2
          ? this.serveInstTime2[1]
          : '',
        intermediaryFirstType: 1,
        intermediaryRejectType: 2
      }
      insertOrUpdateEntWhiteSetting(data).then(res => {
        if (res.data.code == '0000') {
          this.insertOrUpdateUploadInvoiceSetting()
          this.updateCashSetting()
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    insertOrUpdateUploadInvoiceSetting() {
      const data = {
        firstStartTime: this.invoiceTime1 ? this.invoiceTime1[0] : '',
        firstEndTime: this.invoiceTime1 ? this.invoiceTime1[1] : '',
        rejectStartTime: this.invoiceTime2 ? this.invoiceTime2[0] : '',
        rejectEndTime: this.invoiceTime2 ? this.invoiceTime2[1] : '',
        firstType: '1',
        rejectType: '2'
      }
      insertOrUpdateUploadInvoiceSetting(data).then(res => {
        if (res.data.code == '0000') {
          // this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 机构提交兑付资料
    updateCashSetting() {
      const data = {
        isOpen: this.isOpen,
        id: this.cashId
      }
      editorCashSetting(data).then(res => { })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  position: relative;
  overflow: auto;
}
.title {
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &::before {
    content: '';
    width: 4px;
    height: 20px;
    margin-right: 5px;
    border-radius: 2px;
    display: inline-block;
    background: #46a6ff;
  }
}
/deep/ .picker-date {
  .el-date-picker__header {
    span:nth-child(3) {
      /*第三个标签是span的标签，把它隐藏*/
      display: none;
    }
    button:nth-child(1) {
      display: none;
    }
    button:nth-child(5) {
      display: none;
    }
  }
}
.body {
  font-size: 14px;
  > div {
    margin-bottom: 30px;
  }
  .tips {
    color: #606266;
  }
}
.foot {
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
}
</style>
